import axios from "axios";
import { baseURL } from "../config/api";

export const getLocation = () => {
    return getFetch(`locations/GetActiveLocations`)
}

export const getLoctionOpenHours = () => {
    return getFetch(`locationOpenHours`)
}

const getFetch = (url: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        params: params
    }).then(response => response.data);
}